
export const merchantDisplay = "Geopagos Apple Pay";
export const paymentRequestApi = null;

export const APPLE_PAY_VERSION_NUMBER = 3;

const merchantIdentifierElement = document.getElementById('merchantIdentifierInfo');
export const merchantIdentifier = merchantIdentifierElement != null ? merchantIdentifierElement.innerHTML : '0';


// WEBPACK FOOTER //
// ./client/components/PaymentConf.js